import React, { useEffect } from "react";
import { useOptimizerNavigation } from "./useOptimizerNavigation";
import RuvnlOptimizerDas from "./OptimizerDas";

import RuvnlSimulationIndex from "./SimulationOptimizer/SimulationIndex";
import RuvnlSimulationOptimization from "./SimulationOptimizer/OptimizationIndex";
import { getGNAOptimizerSession } from "../../../Rest_api/DemoRestApi";
import { setOptimizerDemoDateRange } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerDate";
import { setOptimizerDemoSession } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerSession";
import { setOptimizerDemoSessionToken } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerSessionToken";
import { useDispatch } from "react-redux";

const OptimizerRouter: React.FC = () => {
  const { currentPage } = useOptimizerNavigation();
  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerRuvnlSession() {
      const data = await getGNAOptimizerSession();
      if (data) {
        dispatch(
          setOptimizerDemoDateRange({
            startDate: data.start_date,
            endDate: data.end_date,
          })
        );
        dispatch(setOptimizerDemoSession(data.session));
        dispatch(setOptimizerDemoSessionToken(data.session_token));
      }
    }
    localStorage.removeItem("OptimizerTab");
    OptimizerRuvnlSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "generation":
        return <RuvnlSimulationIndex />;
      case "optimisation":
        return <RuvnlSimulationOptimization />;
      default:
        return <RuvnlOptimizerDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default OptimizerRouter;
